/**
 * 安聆 SafeListen - 接收端预警记录列表（收到推送时自动追加显示）
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import './AlertLog.css';

function formatTime(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString('zh-CN', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } catch (_) {
    return iso || '--';
  }
}

export default function AlertLog({ items = [] }) {
  const { t } = useTranslation();
  if (items.length === 0) {
    return (
      <div className="safelisten-card alert-log">
        <div className="alert-log-title">{t('guard.alertLogTitle')}</div>
        <div className="alert-log-empty">{t('guard.noAlertLog')}</div>
      </div>
    );
  }
  return (
    <div className="safelisten-card alert-log">
      <div className="alert-log-title">{t('guard.alertLogTitle')}</div>
      <ul className="alert-log-list">
        {[...items].reverse().map((item) => (
          <li key={item.id} className="alert-log-item">
            {t('guard.alertItem', { time: formatTime(item.at) })}
          </li>
        ))}
      </ul>
    </div>
  );
}
